module.exports = __webpack_public_path__ + "json/market5-0.json?9a0c769dbee555fa0a2916a70e58fa79";


//////////////////
// WEBPACK FOOTER
// ./src/assets/packed/market/market5-0.json
// module id = 1266
// module chunks = 3